// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Labels = require("../../../reason/clients/components/Labels.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var AgentPropertyMlsStatus = require("../../common/Agent/AgentPropertyMlsStatus.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RentalPropertyStatus_rentalPropertyV5_graphql = require("../../../__generated__/RentalPropertyStatus_rentalPropertyV5_graphql.bs.js");

var convertFragment = RentalPropertyStatus_rentalPropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RentalPropertyStatus_rentalPropertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RentalPropertyStatus_rentalPropertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, RentalPropertyStatus_rentalPropertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RentalPropertyStatus_rentalPropertyV5_graphql.node, convertFragment, fRef);
}

var PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function RentalProperty__Status$WithoutErrorBoundary(props) {
  var size = props.size;
  var property = use(props.property);
  var match = property.status;
  var tmp;
  switch (match.__typename) {
    case "ExpiredProperty" :
        tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {}),
                JsxRuntime.jsx(AgentPropertyMlsStatus.make, {
                      property: property.fragmentRefs,
                      size: size
                    })
              ]
            });
        break;
    case "RentedProperty" :
        tmp = JsxRuntime.jsx(Labels.RentedLabel.make, {});
        break;
    case "WithdrawnProperty" :
        tmp = JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
        break;
    case "ActiveProperty" :
    case "__unselected" :
        tmp = JsxRuntime.jsx(AgentPropertyMlsStatus.make, {
              property: property.fragmentRefs,
              size: size
            });
        break;
    
  }
  return JsxRuntime.jsx("div", {
              children: tmp,
              className: "flex gap-4"
            });
}

var WithoutErrorBoundary = {
  make: RentalProperty__Status$WithoutErrorBoundary
};

function RentalProperty__Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "property status",
              children: JsxRuntime.jsx(RentalProperty__Status$WithoutErrorBoundary, {
                    property: props.property,
                    size: props.size
                  })
            });
}

var make = RentalProperty__Status;

exports.PropertyFragment = PropertyFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
